import React, { useState } from "react";
import "miew/dist/miew.min.css";
import { StandaloneStructServiceProvider } from "ketcher-standalone";
import { Editor } from "ketcher-react";
import "ketcher-react/dist/index.css";


// "Open... (⌘+O)","css-x7sio", "open-file-button"

const structServiceProvider = new StandaloneStructServiceProvider();

const KetcherExample = () => {
  const [ketcher, setKetcher] = useState(null);

  const handleOnInit = async (ketcherInstance) => {
    setKetcher(ketcherInstance);
    window.ketcher = ketcherInstance;

    // Disable the "open-file-button" element
    const openFileButton = document.querySelector('[data-testid="open-file-button"]');
    if (openFileButton) {
      openFileButton.disabled = true;
    }

    
  };

  return (
    <Editor
      errorHandler={(message) => null}
      staticResourcesUrl={""}
      structServiceProvider={structServiceProvider}
      onInit={handleOnInit}
      
    />
  );
};

export default KetcherExample;
